import { useMutation } from 'react-query';
import { ResourceType } from 'types/common';
import { fetchWrapper } from 'utils/fetchWrapper';

export type RemoveOperationMutationVariables = {
  type: ResourceType;
  id: string;
};

export function useBatchRemoveOperations() {
  const performBatchOperations = (
    mutationVariables: RemoveOperationMutationVariables[]
  ) => {
    const body = {
      'atomic:operations': mutationVariables.map((variable) => ({
        op: 'remove',
        ref: {
          type: variable.type,
          id: variable.id,
        },
      })),
    };

    return fetchWrapper<unknown>({
      url: 'Operations',
      method: 'POST',
      body,
      additionalHeaders: {
        'Content-Type':
          'application/vnd.api+json; ext="https://jsonapi.org/ext/atomic"',
        Accept:
          'application/vnd.api+json; ext="https://jsonapi.org/ext/atomic"',
      },
    });
  };
  return useMutation('batch operations', performBatchOperations);
}
